import { useState, useEffect } from 'react';
import { getCourses, getCourseName} from '../data/course-data';
// import Pay from './pay';
import Swal from 'sweetalert2';
import $  from 'jquery';
import { useLocation } from 'react-router-dom';
// const testStyle = {
//     color: 'white',
//     backgroundColor: 'black'
// }
async function register(credentials) {
    // https://server.abiatechhub.com/register
    //http://localhost:3001/register
	return fetch('https://server.abiatechhub.com/register', {
	  method: 'POST',
	  headers: {
		'Content-Type': 'application/json'
	  },
	  body: JSON.stringify(credentials)
	}).then(data => data.json()).catch(err => Swal.fire({
            title: 'Something went wrong!',
            icon: 'error',
            confirmButtonText: 'Try again',
    }).then((result) => {
        if(result.isConfirmed){
            $('#regbut').html('Register');
        }
    })
    );
   }
  
const Register = () => {
    const location = useLocation();
    const [firstname, setFirstName] = useState('');
	const [lastname, setLastName] = useState('');
	const [phoneno, setPhoneNo] = useState('');
    const [email, setEmail] = useState('');
    const [residence, setResidence] = useState('');
    const [course, setCourse] = useState('');
    const [errors, setErrors] = useState({});

    useEffect(() => {
        // Get course from URL parameters
        const params = new URLSearchParams(location.search);
        const courseFromUrl = params.get('course');
        if (courseFromUrl) {
            // Find the course in the courses list to ensure exact match
            const courses = getCourses();
            const matchedCourse = courses.find(c => c.name === courseFromUrl);
            if (matchedCourse) {
                setCourse(matchedCourse.name);
            }
        }
    }, [location]);

    const validateForm = () => {
        const newErrors = {};
        
        // Check for empty fields and trim whitespace
        if (!firstname?.trim()) newErrors.firstname = 'First name is required';
        if (!lastname?.trim()) newErrors.lastname = 'Last name is required';
        if (!phoneno?.trim()) newErrors.phoneno = 'Phone number is required';
        if (!email?.trim()) newErrors.email = 'Email is required';
        if (!residence?.trim()) newErrors.residence = 'Residence is required';
        if (!course?.trim()) newErrors.course = 'Course selection is required';

        // Enhanced phone number validation for international numbers
        // Remove any spaces and convert 'O' to '0'
        const cleanPhone = phoneno?.replace(/\s+/g, '').replace(/O/gi, '0');
        
        // Check if phone number contains only digits and valid international format
        if (cleanPhone) {
            // Must start with + followed by country code, or just digits
            const validFormat = /^\+?\d+$/.test(cleanPhone);
            // Must be between 8 and 15 digits (international standard)
            const validLength = cleanPhone.length >= 8 && cleanPhone.length <= 15;
            
            if (!validFormat || !validLength) {
                newErrors.phoneno = 'Please enter a valid international phone number (e.g., +1234567890 or 1234567890)';
            }
        }

        // Validate email format
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (email && !emailRegex.test(email)) {
            newErrors.email = 'Please enter a valid email address';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

	const handleSubmit = async e => {
        e.preventDefault();
        
        if (!validateForm()) {
            Swal.fire({
                title: 'Validation Error',
                text: 'Please check the form for errors',
                icon: 'error',
                confirmButtonText: 'OK'
            });
            return;
        }

        const courseName = getCourseName(course);
            $('#regbut').html('Please wait <i class="fa fa-spinner-third fa-spin fa-1x fa-pulse ms-3"></i>');
        
        // Clean phone number before submission
        const cleanPhone = phoneno.replace(/\s+/g, '').replace(/O/gi, '0');
        
            const response = await register({
            firstname: firstname.trim(),
            lastname: lastname.trim(),
            phoneno: cleanPhone,
            email: email.trim(),
            residence: residence.trim(),
            course: course.trim()
            });
            if(response){
            if(response.status === 200){
                $('#regbut').html('Register');
                Swal.fire({
                    title: response.message,
                    text: "Would you like to proceed to payment?",
                    icon: 'success',
                    showCancelButton: true,
                    confirmButtonColor: '#198754',
                    confirmButtonText: '<i class="fa fa-thumbs-up"></i> Ok!',
                    cancelButtonText: "<i class='fa fa-thumbs-up'></i> I'll visit the hub!",
                  }).then((result) => {
                    if (result.isConfirmed) {
                           const config =  {
                                reference: "ATHACADEMY"+(new Date()).getTime().toString(),
                                email: response.userEmail,
                                amount: courseName.price*100,
                                publicKey: 'pk_live_4dbf686ee1fcdf6cff24e049f6697e6a3ec53e91',
                            }
                            //pk_live_4dbf686ee1fcdf6cff24e049f6697e6a3ec53e91
                        sessionStorage.setItem('config',JSON.stringify(config));
                        window.location.href = "/pay";
                    }else{
                        window.location.href = "/contact";
                    }
                  })
                // $('.alert-danger').hide();
                // $('.alert-success').html(response.message)
                // $('.alert-success').show();
            }else if(response.status === 400){
                Swal.fire({
                    title: response.message,
                    icon: 'error',
                    confirmButtonText: 'Try again',
                  }).then((result) => {
                    if(result.isConfirmed){
                        $('#regbut').html('Register');
                    }
                  });
            }
        }
	  }
    let courses = getCourses();
    return(
        <section className="woocommerce single page-wrapper">
    <div className="container">
        <div className="row justify-content-center">
            <div className="col-md-8 col-xl-7">
                
                <div className="signup-form">
                    <div className="form-header">
                        <h2 className="font-weight-bold mb-3">Sign Up For a Course</h2>
                        {course && <p className="text-success">Selected Course: {course}</p>}
                    </div>

                    <form method="post" onSubmit={handleSubmit} className="woocommerce-form woocommerce-form-register register">

                        <div className="row">
                            <div className="col-xl-6">
                                <p className="woocommerce-form-row woocommerce-form-row--wide form-row form-row-wide">
                                    <label>First Name&nbsp;<span className="required">*</span></label>
                                    <input type="text" className={`form-control ${errors.firstname ? 'is-invalid' : ''}`} name="first-name" placeholder="First Name" onChange={e => setFirstName(e.target.value)} required/>
                                    {errors.firstname && <div className="invalid-feedback">{errors.firstname}</div>}
                                </p>
                            </div>
                            <div className="col-xl-6">
                                <p className="woocommerce-form-row woocommerce-form-row--wide form-row form-row-wide">
                                    <label>Last Name&nbsp;<span className="required">*</span></label>
                                    <input type="text" className={`form-control ${errors.lastname ? 'is-invalid' : ''}`} name="last-name"  placeholder="Last Name" onChange={e => setLastName(e.target.value)} required/>
                                    {errors.lastname && <div className="invalid-feedback">{errors.lastname}</div>}
                                </p>
                            </div>
                            <div className="col-xl-6">
                                <p className="woocommerce-form-row woocommerce-form-row--wide form-row form-row-wide">
                                    <label>Phone Number&nbsp;<span className="required">*</span></label>
                                    <input type="tel" className={`form-control ${errors.phoneno ? 'is-invalid' : ''}`} name="phoneno" placeholder="Your Phone No." onChange={e => setPhoneNo(e.target.value)} required/>
                                    {errors.phoneno && <div className="invalid-feedback">{errors.phoneno}</div>}
                                </p>
                            </div>
                            <div className="col-xl-6">
                                <p className="woocommerce-form-row woocommerce-form-row--wide form-row form-row-wide">
                                    <label>Email&nbsp;<span className="required">*</span></label>
                                    <input type="email" className={`form-control ${errors.email ? 'is-invalid' : ''}`} name="email" placeholder="Your Email" onChange={e => setEmail(e.target.value)} required/>
                                    {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                                </p>
                            </div>
                            <div className="col-xl-6">
                                <p className="woocommerce-form-row woocommerce-form-row--wide form-row form-row-wide">
                                    <label>Location&nbsp;<span className="required">*</span></label>
                                    <input type="text" className={`form-control ${errors.residence ? 'is-invalid' : ''}`} name="residence" placeholder="City, Country" onChange={e => setResidence(e.target.value)} required/>
                                    {errors.residence && <div className="invalid-feedback">{errors.residence}</div>}
                                </p>
                            </div>
                            <div className="col-xl-6">
                            <p className="woocommerce-form-row woocommerce-form-row--wide form-row form-row-wide">
                                    <label>Course&nbsp;<span className="required">*</span></label>
                                    <select 
                                        name="course" 
                                        id="course" 
                                        className={`form-control ${errors.course ? 'is-invalid' : ''}`} 
                                        onChange={e => setCourse(e.target.value)} 
                                        value={course}
                                        required
                                    >
                                        <option value="" disabled>Select course</option>
                                        {courses.map(
                                            course => (
                                                <option key={course.id} value={course.name}>{course.name}</option>
                                            )
                                        )}
                                    </select>
                                    {errors.course && <div className="invalid-feedback">{errors.course}</div>}
                            </p>
                            </div>

                            <div className="col-xl-12">
                                <div className="d-flex align-items-center justify-content-between py-2">
                                    <p className="form-row">
                                        <label className="woocommerce-form__label woocommerce-form__label-for-checkbox woocommerce-form-login__policy">
                                            <input className="woocommerce-form__input woocommerce-form__input-checkbox" name="policy" type="checkbox" id="policy" defaultValue="forever"  required/> <span>Accept the Terms and Privacy Policy</span>
                                        </label>
                                    </p>
                               </div>
                            </div>
                        </div>
                        <p className="woocommerce-FormRow form-row">
                            <button type="submit" className="woocommerce-button button" name="register" defaultValue="Register" id="regbut">Register </button>
                        </p>
                    </form>
                </div>
            </div>
        </div>
    </div>
</section>
    )
}

export default Register;